<template>
  <dialog ref="dialogRef" class="modal">
    <div class="modal-box p-0 w-11/12 max-w-md">
      <div class="flex items-center justify-between px-4 py-3 border-b border-base-200">
        <div class="flex items-center gap-2">
          <i class="bi bi-bell-fill opacity-70"></i>
          <h3 class="font-semibold text-sm">Notifications</h3>
        </div>

        <button
          type="button"
          class="btn btn-ghost btn-xs"
          :disabled="notifications.length === 0 || notificationsStore.unreadCount === 0"
          @click="notificationsStore.markAllAsRead()"
        >
          Mark all as read
        </button>
      </div>

      <div v-if="notifications.length === 0" class="px-4 py-8 text-center text-sm opacity-70">
        No notifications
      </div>

      <ul v-else class="max-h-96 overflow-auto">
        <li
          v-for="n in notifications"
          :key="n.id"
          class="border-b border-base-200 last:border-b-0"
        >
          <button
            type="button"
            class="w-full text-left px-4 py-3 hover:bg-base-200/40"
            :class="{ 'bg-base-200/20': !n.read_at }"
            @click="notificationsStore.markAsRead(n.id)"
          >
            <div class="flex items-start justify-between gap-3">
              <div class="min-w-0">
                <p class="text-sm font-semibold" :class="{ 'text-primary': !n.read_at }">
                  {{ n.title }}
                </p>
                <p class="text-xs opacity-70">
                  {{ n.body }}
                </p>
                <p class="text-[11px] opacity-50 mt-1">
                  {{ formatDate(n.created_at) }}
                </p>
              </div>

              <span
                v-if="!n.read_at"
                class="badge badge-xs rounded-full bg-red-500 text-white px-1.5 border-none text-[10px] shrink-0 mt-0.5"
              >
                NEW
              </span>
            </div>
          </button>
        </li>
      </ul>

      <div class="flex justify-end gap-2 px-4 py-3 border-t border-base-200">
        <form method="dialog">
          <button class="btn btn-ghost btn-sm">Close</button>
        </form>

        <button class="btn btn-primary btn-sm" @click="goToAll">
          View all
          <i class="bi bi-arrow-right-short text-lg"></i>
        </button>
      </div>
    </div>

    <form method="dialog" class="modal-backdrop">
      <button aria-label="Close"></button>
    </form>
  </dialog>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore, useNotificationsStore } from "@/stores";
import {storeToRefs} from "pinia";

const auth = useAuthStore();
const router = useRouter();
const notificationsStore = useNotificationsStore();
const {notifications} = storeToRefs(notificationsStore);
const dialogRef = ref(null);

function open() {
  dialogRef.value?.showModal?.();
}

function goToAll() {
  dialogRef.value?.close?.();

  const base =
    auth.user?.user_type === "airline"
      ? "/airline"
      : auth.user?.user_type === "charterer"
        ? "/charterer"
        : "/";

  router.push(`${base}/notifications`);
}

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return "";
  }
}

defineExpose({ open });
</script>